import React, { useState, useEffect } from "react";
import { roleMappingFromNumber } from "api/apiHelpers.js";
import { getRoleSVG } from "lib/role_helper";
import { useLightMode } from "hooks/general-hooks";

const MatchStatsExpanded = (props) => {
  const { lightModeOn } = useLightMode();
  const { matchSummaryPages, summonerName, totalGames } = props;
  const [rolesPlayed, setRolesPlayed] = useState({});

  useEffect(() => {
    setRolesPlayed(getRolesPlayed(matchSummaryPages, summonerName));
  }, [matchSummaryPages]);

  const getRolesPlayed = (matches, summoner) => {
    let roles = {
      top: 0,
      jungle: 0,
      mid: 0,
      adc: 0,
      supp: 0,
    };
    for (const [key, value] of Object.entries(matches)) {
      for (const [subKey, gameData] of Object.entries(value)) {
        for (const [idx, user] of gameData["teamA"].concat(gameData["teamB"]).entries()) {
          if (user["summonerName"].toLowerCase() === summoner && roleMappingFromNumber(user["role"]) in roles) {
            roles[roleMappingFromNumber(user["role"])] += 1;
          }
        }
      }
    }
    return roles;
  };

  return (
    <div className="match-stats-expanded">
      <h1 className="match-stats-title">Preferred Roles</h1>
      <div className="match-stats-content">
        {Object.entries(rolesPlayed).map(([key, value]) => (
          <div key={key} className="role">
            {getRoleSVG(key, { lightModeOn })}
            <div className="progress-bar">
              <div style={{ width: `${(value / totalGames) * 100}%` }} className="progress"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MatchStatsExpanded;
